import React, { Component } from 'react';
import EmployeeRelatedConfigPage from './employees-config-html';
class EmployeeRelatedConfig extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <EmployeeRelatedConfigPage
                />
            </div>
        )
    }
}
export default EmployeeRelatedConfig;